import { Link } from "react-router-dom";

const ConsentCheckbox = ({ id, checked, onChange }) => (
  <div className="flex items-start gap-3">
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      required
      className="mt-1 h-4 w-4 flex-shrink-0 accent-[#2E4A91] cursor-pointer"
      data-testid={`${id}-checkbox`}
    />
    <label htmlFor={id} className="text-sm text-slate-600 leading-relaxed cursor-pointer">
      Запознат/а съм с{" "}
      <Link
        to="/politika-za-poveritelnost"
        target="_blank"
        className="text-[#2E4A91] font-medium underline hover:text-[#2ED573]"
        data-testid={`${id}-privacy-link`}
      >
        Политиката за поверителност
      </Link>{" "}
      и съм съгласен/на данните ми да бъдат обработени за отговор на запитването. *
    </label>
  </div>
);

export default ConsentCheckbox;
